import Text from 'components/ui/Text';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { WITHDRAWAL_ROUTES } from 'utils/withdrawalRoutes';

const WithdrawalError = () => {
    const { t } = useTranslation();

    return (
        <div>
            <h1>{t('withdrawal_error_title')}</h1>
            <Text className="mb-3">{t('withdrawal_error_message')}</Text>
            <Link to={WITHDRAWAL_ROUTES.lookup}>{t('withdrawal_try_again')}</Link>
        </div>
    );
};

export default WithdrawalError;
